<template>
  <expose-inquiry-wizard :object-id="objectId" :custom-object-id="customObjectId"></expose-inquiry-wizard>
</template>

<script>
import ExposeInquiryWizard from "./ExposeInquiryWizard";

export default {
  name: "ExposeInquiryWizardApp",

  components: {
    ExposeInquiryWizard
  },

  data() {
    return {
      objectId: null,
      customObjectId: null
    }
  },

  created() {
    const urlParams = new URLSearchParams(window.location.search);
    this.objectId = urlParams.get("objectId");
    this.customObjectId = urlParams.get("customObjectId");
  }
};
</script>
